import request from '@/request'
import handler from '@/utils/responseHandler'

/*
  选择站点相关接口
  331532    查询最新站点信息
  331545    定位城市车站信息
*/
export default {
  /**
   * 查询最新站点信息
   */
  '331532': (versionTime) => request.ticket({
    url: '/gateway/gtgj/dyn',
    data: {
      pid: 331532,
      versionTime: versionTime || ''
    },
    sidFields: ['uid', 'pid']
  }).then(handler.resBdData),
  /**
   * 定位城市车站信息
   */
  '331545': () => request.ticket({
    url: '/gateway/gtgj/dyn',
    data: {
      pid: 331545
    },
    sidFields: ['uid', 'pid']
  }).then(handler.resBdData)
}



// WEBPACK FOOTER //
// ./src/api/selectStation.js